import { bool, func, number, string } from 'prop-types';
import React from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Icon from 'yoda-core-components/lib/components/Icon';
import VideoNew from 'yoda-core-components/lib/assets/svg/VideoNew.svg';
import { isDesktopWidth } from 'yoda-core-components/lib/helpers/Utils/mediaQuery';
import VideoPlayer from '../../../VideoPlayer/VideoPlayerLazy';

const ProductVideo = (props) => {
    const {
        galleryProductCard,
        index,
        playVideo,
        renderVideo,
        setParentState,
        triggerAnalytics,
        videoId,
    } = props;

    if (isDesktopWidth() && videoId) {
        const buttonClasses = dt(['sm:hidden', 'absolute', 'lg:block', '-bottom-0.5']);
        const dataAutomationId = galleryProductCard ? `gallery-video-${videoId}` : '';
        const iconSize = !__SERVER__ && window.innerWidth >= 1440 ? '40' : '32';
        const pageId = galleryProductCard ? 'galleryVideo' : '';
        const videoWrapper = dt(['absolute', 'h-full', 'w-full', 'left-0', 'top-0', 'z-1']);

        const startVideo = () => {
            setParentState(true);
        };

        const stopVideo = () => {
            setParentState(false);
        };

        const renderPlayer = () => {
            return renderVideo ? (
                <div className={videoWrapper}>
                    <VideoPlayer
                        automationId={dataAutomationId}
                        index={index}
                        onEnd={stopVideo}
                        pageId={pageId}
                        triggerAnalytics={triggerAnalytics}
                        videoId={videoId}
                    />
                </div>
            ) : null;
        };

        const renderButton = () => {
            return (
                <div className={buttonClasses} data-automation-id={`product-video-${index}`}>
                    <button onClick={startVideo} type="button">
                        <Icon
                            automationId="video-automation-product"
                            height={iconSize}
                            width={iconSize}
                        >
                            <VideoNew />
                        </Icon>
                    </button>
                </div>
            );
        };

        return playVideo ? renderPlayer() : renderButton();
    }

    return null;
};

ProductVideo.propTypes = {
    setParentState: func.isRequired,
    galleryProductCard: bool,
    index: number,
    playVideo: bool,
    renderVideo: bool,
    triggerAnalytics: func,
    videoId: string,
};

ProductVideo.defaultProps = {
    galleryProductCard: false,
    index: 0,
    playVideo: false,
    renderVideo: false,
    triggerAnalytics: null,
    videoId: '',
};

export default ProductVideo;
